var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 384.921,
    height: 177.604,
    viewBox: "0 0 384.921 177.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.532,
    y1: 0.548,
    x2: 0.533,
    y2: 0.963,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9aa9ff",
    stopOpacity: 0.239
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d5580",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2107.677 -313.975)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.099 -1243.025)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1523.565,1719.9c-1.4-1.4,37.53-35.426,37.53-35.426l37.179,25.6,42.441-59.276,37.881,33.672,41.038-33.672,38.232,43.142,43.142-76.112,38.232,14.03,41.915-79.62",
    fill: "none",
    stroke: "#9aa9ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.774 5.846)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 382.226,
    transform: "translate(1518.5 1561.5)",
    fill: "none",
    stroke: "rgba(112,112,112,0.4)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 382.226,
    transform: "translate(1518.5 1618.5)",
    fill: "none",
    stroke: "rgba(112,112,112,0.4)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 382.226,
    transform: "translate(1518.5 1675.5)",
    fill: "none",
    stroke: "rgba(112,112,112,0.4)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.153,1552.238l-41.915,79.62-38.232-14.03-43.142,76.112-38.232-43.142-41.038,33.672-37.881-33.672-42.441,59.276-37.179-25.6s-38.933,34.023-37.53,35.426,357.588-2.446,357.588-2.446Z",
    transform: "translate(-7 -6)",
    fill: "url(#a)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(1866 1557)",
    fill: "#9aa9ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGraph);
export default __webpack_public_path__ + "static/media/hero_graph .114984377b5a294c15da8300202a7ed0.svg";
export { ForwardRef as ReactComponent };